import { PaymentMethod } from "../../enums";

import { ContractStep, ContractStepsNames } from "./contractSteps";
import { shouldHaveOwnershipTransfer } from "./rules/shouldHaveOwnershipTransfer";
import { shouldHavePaymentMethod } from "./rules/shouldHavePaymentMethod";
import { getStepOrderByName } from "./utils/getStepOrderByName";

import { Contract } from "@/components/Contracts/contract.interface";
import { BusinessUnit } from "@/modules/User/types/types";

type VerifyContractStepsProps = {
  selectedBU: BusinessUnit;
  setMaxStep: (step: number) => void;
  currentContract: Contract;
  setCurrentStep?: (step: number) => void;
  currentStepOrder: number;
  contractSteps: ContractStep[];
  hasSeenGenerateContractTermsStepRef: React.MutableRefObject<boolean>;
};

const isAccountFilled = (
  currentContract: Contract,
  selectedBU: BusinessUnit
): boolean => {
  const { account, accountDocument, accountContact, checkingAccount } =
    currentContract;

  return (
    account &&
    accountDocument &&
    accountContact &&
    (selectedBU.paymentMethod !== PaymentMethod.DEBITO_AUTOMATICO ||
      checkingAccount)
  );
};

export const verifyContractSteps = ({
  selectedBU,
  setMaxStep,
  currentContract,
  setCurrentStep,
  currentStepOrder,
  contractSteps,
  hasSeenGenerateContractTermsStepRef
}: VerifyContractStepsProps) => {
  const goToStep = ({
    currentStep,
    maxStep
  }: {
    currentStep: ContractStepsNames;
    maxStep?: ContractStepsNames;
  }) => {
    const DEFAULT_MAX_STEP = ContractStepsNames.BENEFICIOS;
    const defaultMaxStepOrder = getStepOrderByName(
      currentContract,
      DEFAULT_MAX_STEP
    );
    const maxStepOrder = getStepOrderByName(currentContract, maxStep);
    const currentStepOrder = getStepOrderByName(currentContract, currentStep);

    setCurrentStep?.(currentStepOrder);
    setMaxStep(maxStep ? maxStepOrder : defaultMaxStepOrder);
  };

  const currentStep = contractSteps?.[currentStepOrder];
  const accountFilled = isAccountFilled(currentContract, selectedBU);
  const hasItems = currentContract.items?.length > 0;
  const hasShipping = !!currentContract?.shipping;
  const contractHasOwnershipTransfer =
    shouldHaveOwnershipTransfer(currentContract);

  const needToAssignPaymentMethod = shouldHavePaymentMethod(
    currentContract,
    currentStep
  );

  if (!accountFilled) {
    goToStep({ currentStep: ContractStepsNames.COOPERADO });
    return;
  }

  if (!hasItems || !hasShipping) {
    goToStep({ currentStep: ContractStepsNames.BENEFICIOS });
    return;
  }

  if (needToAssignPaymentMethod) {
    goToStep({
      currentStep: ContractStepsNames.METODO_DE_PAGAMENTO,
      maxStep: ContractStepsNames.METODO_DE_PAGAMENTO
    });
    return;
  }

  // if (
  //   contractHasOwnershipTransfer &&
  //   !hasSeenGenerateContractTermsStepRef.current
  // ) {
  //   goToStep({
  //     currentStep: ContractStepsNames.TERMOS,
  //     maxStep: ContractStepsNames.TERMOS
  //   });
  //   return;
  // }

  if (accountFilled && hasItems && !needToAssignPaymentMethod) {
    goToStep({
      currentStep: ContractStepsNames.CONFIRMACAO,
      maxStep: ContractStepsNames.CONFIRMACAO
    });
  }
};
